import client from "services/ngage/api-client";
import DataPage from "types/DataPage";
import {dateTime} from "services/date";
import {EventType, EventTypeData} from "types/EventType";

/**
 * Get all event types (paginated)
 */
const all = async (page: number = 1) => {
    const response = await client.get<DataPage<EventType> | null>(`/event-types?page=${page}`)

    if(response.data){
        response.data.data = response.data.data.map((eventType) => {
            eventType.created_at = dateTime(eventType.created_at)
            eventType.updated_at = dateTime(eventType.updated_at)

            return eventType
        })
    }

    return response.data
}

/**
 * Get a single event type
 *
 * @param {number} id
 */
const get = async (id: number) => {
    const response = await client.get<EventType>(`/event-types/${id}`)
    return response.data
}

/**
 * Store a new event type
 *
 * @param data
 */
const store = async (data: EventTypeData) => {
    const response = await client.post<EventType>('/event-types', data)
    return response.data
}

/**
 * Update an existing event type
 *
 * @param {number} id
 * @param data
 */
const update = async (id: number, data: EventTypeData) => {
    const response = await client.put<EventType>(`/event-types/${id}`, data)
    return response.data
}

/**
 * Permanently delete an event type
 *
 * @param {number} id
 */
const destroy = async (id: number) => {
    const response = await client.delete<null>(`/event-types/${id}`)
    return response.status === 204
}

const eventTypes = {
    all,
    get,
    store,
    update,
    destroy
}

export default eventTypes;